import React from 'react';
import './PC.css';
import Amazon from '../../img/pc/Amazon.png'
import Apple from '../../img/pc/Apple.png'
import Booking from '../../img/pc/Booking.png'
import EPAMGlobal from '../../img/pc/EPAMGlobal.png'
import Layfer from '../../img/pc/Layfer.png'
import Naumova from '../../img/pc/Naumova.png'
import Oparina from '../../img/pc/Oparina.png'
import Remati from '../../img/pc/Remati.png'
import Talent from '../../img/pc/Talent.png'
import Tretyak from '../../img/pc/Tretyak.png'
import Tsvik from '../../img/pc/Tsvik.png'
import Wheely from '../../img/pc/Wheely.png'

export default class PC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      speakers: [
        {
          photo: Remati,
          name: 'Andre Remati',
          position: 'Product & Marketing Manager',
          logo: EPAMGlobal,
        },
        {
          photo: Layfer,
          name: 'Rodion Layfer',
          position: 'Senior Technical Program Manager',
          logo: Amazon,
        },
        {
          photo: Tretyak,
          name: 'Tatiana Tretyak',
          position: 'Product manager',
          logo: Booking,
        },
        {
          photo: Tsvik,
          name: 'Michael Tsvik',
          position: 'Senior Product Manager',
          logo: Wheely,
        },
        {
          photo: Naumova,
          name: 'Anna Naumova',
          position: 'Product Manager',
          // logo: Apple,
        },
        {
          photo: Oparina,
          name: 'Polina Oparina',
          position: 'Senior Product Manager',
          logo: Talent,
        },
      ],
    }
  }

  renderPC(item, i) {
    return (
      <div className="pc_item" key={`team-${i}`}>
        <div className='pc_info' style={{ backgroundImage: `url(${item.photo}` }}>
          <p className="pc_name p1">{item.name}</p>
          <p className="pc_position p2">{item.position}</p>
          <img className='pc_logo' src={item.logo} alt="" />
          <div className="pc_links">
            {item.fb && <a className="social_link social_fb" target='_blank' rel="noreferrer" href={item.fb}></a>}
            {item.ln && <a className="social_link social_ln" target='_blank' rel="noreferrer" href={item.ln}></a>}
            {item.tw && <a className="social_link social_tw" target='_blank' rel="noreferrer" href={item.tw}></a>}
            {item.github && <a className="social_link social_github" target='_blank' rel="noreferrer" href={item.github}></a>}
            {item.website && <a className="social_link social_website" target='_blank' rel="noreferrer" href={item.website}></a>}
            {item.youtube && <a className="social_link social_yb" target='_blank' rel="noreferrer" href={item.youtube}></a>}
            {item.twitch && <a className="social_link social_twitch" target='_blank' rel="noreferrer" href={item.twitch}></a>}
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="pc_wrap pc_wrap--mb" id='speakers'>
        <div className='container pc'>
          <h2 className='pc_title pc_main'>Program committee</h2>
          <div className='pc_block'>
            {this.state.speakers.map((item, i) => this.renderPC(item, i))}
          </div>
        </div>
      </div>
    )
  }
}